function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import cx from 'classnames';
var clsPrefix = 'tcpc-button';

var Button = function Button(props) {
  var _cx;

  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      type = props.type,
      style = props.style,
      onClick = props.onClick,
      size = props.size,
      radius = props.radius,
      inline = props.inline;
  var baseProps = {
    disabled: disabled,
    style: style,
    onClick: onClick,
    className: cx(clsPrefix, className, ["".concat(clsPrefix, "-").concat(type)], ["".concat(clsPrefix, "-").concat(size)], (_cx = {}, _defineProperty(_cx, "".concat(clsPrefix, "-radius"), radius), _defineProperty(_cx, "".concat(clsPrefix, "-inline"), inline), _cx))
  };
  return /*#__PURE__*/React.createElement("button", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("span", null, children));
};

Button.defaultProps = {
  size: 'large',
  type: 'default',
  disabled: false,
  radius: false,
  inline: false
};
export default Button;